/**
 * 重写 localStorage 和 sessionStorage 的 setItem 和 getItem 方法
 * 在所有key前添加固定前缀
 */

// 保存原始方法引用 - localStorage
const originalLocalSetItem = localStorage.setItem;
const originalLocalGetItem = localStorage.getItem;
const originalLocalRemoveItem = localStorage.removeItem;
const originalLocalClear = localStorage.clear;

// 保存原始方法引用 - sessionStorage
const originalSessionSetItem = sessionStorage.setItem;
const originalSessionGetItem = sessionStorage.getItem;
const originalSessionRemoveItem = sessionStorage.removeItem;
const originalSessionClear = sessionStorage.clear;

// 前缀配置
const KEY_PREFIX = "yq-api_web_";

// 添加前缀的方法
function addPrefix(key) {
    if (key === "client-userInfo" || key === "Authorization") {
        return key;
    }
    return KEY_PREFIX + key;
}

localStorage.setItem = function (key, value) {
    const prefixedKey = addPrefix(key);
    originalLocalSetItem.call(localStorage, prefixedKey, value);
};
localStorage.getItem = function (key) {
    const prefixedKey = addPrefix(key);
    return originalLocalGetItem.call(localStorage, prefixedKey);
};
localStorage.removeItem = function (key) {
    const prefixedKey = addPrefix(key);
    originalLocalRemoveItem.call(localStorage, prefixedKey);
};
localStorage.clear = function () {
    // 原始的clear方法会清除所有项，包括非本应用设置的
    // 我们可以只清除带有特定前缀的项
    const keys = [];
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key.startsWith(KEY_PREFIX)) {
            keys.push(key);
        }
    }
    keys.forEach((key) => {
        originalLocalRemoveItem.call(localStorage, key);
    });
};

sessionStorage.setItem = function (key, value) {
    const prefixedKey = addPrefix(key);
    originalSessionSetItem.call(sessionStorage, prefixedKey, value);
};
sessionStorage.getItem = function (key) {
    const prefixedKey = addPrefix(key);
    return originalSessionGetItem.call(sessionStorage, prefixedKey);
};
sessionStorage.removeItem = function (key) {
    const prefixedKey = addPrefix(key);
    originalSessionRemoveItem.call(sessionStorage, prefixedKey);
};
sessionStorage.clear = function () {
    // 原始的clear方法会清除所有项，包括非本应用设置的
    // 我们可以只清除带有特定前缀的项
    const keys = [];
    for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i);
        if (key.startsWith(KEY_PREFIX)) {
            keys.push(key);
        }
    }
    keys.forEach((key) => {
        originalSessionRemoveItem.call(sessionStorage, key);
    });
};
// 导出兼容API，使用方式与原生API相同
export default {
    /**
     * 设置本地存储 (localStorage)
     * @param {string} key 键
     * @param {any} value 值
     */
    set(key, value) {
        localStorage.setItem(key, value);
    },

    /**
     * 获取本地存储 (localStorage)
     * @param {string} key 键
     * @returns {any} 值
     */
    get(key) {
        return localStorage.getItem(key);
    },

    /**
     * 移除本地存储 (localStorage)
     * @param {string} key 键
     */
    remove(key) {
        localStorage.removeItem(key);
    },

    /**
     * 清空所有本地存储 (localStorage)
     */
    clear() {
        localStorage.clear();
    },

    /**
     * 设置会话存储 (sessionStorage)
     * @param {string} key 键
     * @param {any} value 值
     */
    setSession(key, value) {
        sessionStorage.setItem(key, value);
    },

    /**
     * 获取会话存储 (sessionStorage)
     * @param {string} key 键
     * @returns {any} 值
     */
    getSession(key) {
        return sessionStorage.getItem(key);
    },

    /**
     * 移除会话存储 (sessionStorage)
     * @param {string} key 键
     */
    removeSession(key) {
        sessionStorage.removeItem(key);
    },

    /**
     * 清空所有会话存储 (sessionStorage)
     */
    clearSession() {
        sessionStorage.clear();
    },

    /**
     * 获取存储前缀
     * @returns {string} 前缀字符串
     */
    getPrefix() {
        return KEY_PREFIX;
    }
};
